/**
 * Page des statistiques de stream
 * @module pages/StreamStats
 */

import React, { useState } from 'react';
import { useStreamStats } from './hooks/useStreamStats';
import StatCard from './components/StatCard';
import StreamEvolutionCharts from './components/StreamEvolutionCharts';
import '../styles/Dashboard.css';
import '../styles/StreamStats.css';

/**
 * Composant de la page des statistiques de stream
 * @returns {JSX.Element}
 */
function StreamStats() {
  const [range, setRange] = useState('7');
  const { stats, evolution, loading, error, currentEvents, titleRange } =
    useStreamStats(range);
  const timeline = range === '7' ? evolution?.last7Days : evolution?.last30Days;

  return (
    <div className="dashboardPage">
      <main className="mainContent">
        <div className="follows-subs-container">
          <div className="follows-subs-header">
            <div>
              <h2 className="follows-subs-title">Statistiques de Stream</h2>
              <p className="follows-subs-subtitle">
                Bilan de votre activité sur les {titleRange}
              </p>
            </div>
            <div className="follows-subs-actions">
              <button
                className={`sync-button ${range === '7' ? 'active' : ''}`}
                onClick={() => setRange('7')}
              >
                7 jours
              </button>
              <button
                className={`sync-button ${range === '30' ? 'active' : ''}`}
                onClick={() => setRange('30')}
              >
                30 jours
              </button>
            </div>
          </div>

          {loading && (
            <div className="loading-state">
              <span>Chargement des statistiques...</span>
            </div>
          )}

          {error && !loading && (
            <div className="error-state">
              <span>{error}</span>
            </div>
          )}

          {!loading && !error && stats && (
            <>
              <div className="stats-container">
                <StatCard
                  value={
                    (currentEvents?.subs || 0) +
                    (currentEvents?.resubs || 0) +
                    (currentEvents?.giftsubs || 0)
                  }
                  label="Total subs (incl. gifts)"
                />
                <StatCard
                  value={currentEvents?.follows || 0}
                  label="Nouveaux follows"
                />
                <StatCard
                  value={
                    stats.viewers?.[range === '7' ? 'last7Days' : 'last30Days']
                      ?.average ?? '-'
                  }
                  label="Viewers moyens (à venir)"
                />
                <StatCard
                  value={
                    stats.viewers?.[range === '7' ? 'last7Days' : 'last30Days']
                      ?.peak ?? '-'
                  }
                  label="Pic viewers (à venir)"
                />
                <StatCard
                  value={
                    stats.liveTime?.[range === '7' ? 'last7Days' : 'last30Days']
                      ?.totalMinutes ?? '-'
                  }
                  label="Temps live total (à venir)"
                />
              </div>

              <StreamEvolutionCharts timeline={timeline} titleRange={titleRange} />
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default StreamStats;
